import React, { useState, useEffect } from "react"
import {
  Table,
  Input,
  Space,
  message,
  Tooltip,
  Dropdown,
  Tag,
  Menu,
  Form,
  DatePicker,
} from "antd"
import SvgIcon from "src/components/SvgIcon"
import ReportModal from "./Modal/Modal"
import TableCustom from "src/components/Table/CustomTable"
import IconBase from "src/components/IconBase"
import PopupAction from "src/components/PopupAction"
import Button from "src/components/MyButton/Button"
import CB1 from "src/components/Modal/CB1"
import FilterAdmin from "./components/FilterReport"
import ButtonCircle from "src/components/MyButton/ButtonCircle"
import STORAGE, { getStorage } from "src/lib/storage"
import ReportPoolDataService from "src/services/ReportPoolDataService"
import { InputSearchStyle } from "src/pages/ADMIN/HumanResource/styled"
import CustomModal from "src/components/Modal/CustomModal"
import ImportModal from "src/pages/ADMIN/Bussiness/Contact/modal/ImportModalSim"
import TabsBar from "./components/TabsBar"
import dayjs from "dayjs"
import ModalUpdate from "./Modal/ModalUpdate"
import BtnExportExcel from "src/components/BtnExportExcel"
import PermissionGuard from "src/components/PermissionGuard"

const ReportPoolWallet = () => {
  const [data, setData] = useState([])
  const [isModalOpen, setIsModalOpen] = useState(false)
  const [searchValue, setSearchValue] = useState("")
  const [summary, setSummary] = useState({})
  const [filter, setFilter] = useState({})
  const [selectedId, setSelectedId] = useState(null)
  const [modalType, setModalType] = useState(null)
  const [loading, setLoading] = useState(false)
  const [isModalImport, setIsModalImport] = useState(false)
  const [refresh, setRefresh] = useState(false)
  const [monthYear, setMonthYear] = useState()
  const [isEditModalOpen, setIsEditModalOpen] = useState(false)
  const [editingUser, setEditingUser] = useState(null)
  const [tab, setTab] = useState("data")

  const [form] = Form.useForm()

  const [pagination, setPagination] = useState({
    current: 1,
    pageSize: 10,
  })
  const handleEdit = record => {
    setEditingUser(record)
    setIsEditModalOpen(true)
  }
  const columns = [
    // {
    //   title: "ID",
    //   dataIndex: "ID",
    //   key: "ID",
    //   width: 80,
    // },
    {
      title: "Tên khách hàng",
      dataIndex: "customerName",
      key: "customerName",
    },
    {
      title: "Tên thuê bao",
      dataIndex: "subName",
      key: "subName",
    },
    {
      title: "Mã thuê bao",
      dataIndex: "subCode",
      key: "subCode",
    },
    {
      title: "Gói cước",
      dataIndex: "packageName",
      key: "packageName",
    },
    {
      title: "Dung lượng mua",
      dataIndex: "purchasedTraffic",
      key: "purchasedTraffic",
      render: (v) => `${v.toLocaleString()} GB`,
    },
    {
      title: "Tổng dung lượng còn lại",
      dataIndex: "totalRemainingTraffic",
      key: "totalRemainingTraffic",
      render: (v) => `${v.toLocaleString()} GB`,
    },
    {
      title: "Ngày bắt đầu",
      dataIndex: "startDate",
      key: "startDate",
      render: (v) => dayjs(v).format("DD/MM/YYYY"),
    },
    {
      title: "Ngày kết thúc",
      dataIndex: "endDate",
      key: "endDate",
      render: (v) => dayjs(v).format("DD/MM/YYYY"),
    },
    {
      title: "Loại gói",
      dataIndex: "trafficType",
      key: "trafficType",
    },
    {
      title: "Số điện thoại",
      dataIndex: "phoneActive",
      key: "phoneActive",
    },
    {
      title: "Tax",
      dataIndex: "tax",
      key: "tax",
    },
    {
      title: "Giá nhập",
      dataIndex: "import_price",
      render: (value) => Number(value).toLocaleString(),
    },
    // {
    //   title: "Đơn giá",
    //   dataIndex: "unit_price_gb",
    //   render: (value) => value.toLocaleString(),
    // },

    {
      title: "Loại giảm",
      dataIndex: "discount_type",
      render: (val) => {
        if (val === "percent") return <Tag color="blue">Giảm %</Tag>;
        if (val === "fixed") return <Tag color="purple">Giảm cố định</Tag>;
        return <Tag>Không giảm</Tag>;
      },
    },

    {
      title: "Giá trị giảm",
      dataIndex: "discount_value",
      render: (value) => (value ? Number(value) : 0),
    },

    {
      title: "Giá sau giảm",
      dataIndex: "price_discount",
      render: (value) => Number(value).toLocaleString(),
    },
    {
      title: "Trạng thái",
      dataIndex: "status",
      key: "status",
      fixed: "right",
      render: (v) =>
        v === 1 ? (
          <Tag color="green">Hoạt động</Tag>
        ) : (
          <Tag color="red">Không hoạt động</Tag>
        ),
    },
    {
      title: "Hành động",
      dataIndex: "action",
      align: "center",
      fixed: "right",
      render: (_, record) => (
        <PopupAction onClick={e => e.stopPropagation()}>
          <PermissionGuard permission="poolData.walletData.detail">
            <div onClick={() => handleViewDetail(record)}>
              <IconBase name="eye" />
              <span>Xem chi tiết</span>
            </div>
          </PermissionGuard>
          <PermissionGuard permission="poolData.walletData.update">
            <div onClick={() => handleUpdate(record)}>
              <IconBase name="edit" />
              <span>Sửa</span>
            </div>
          </PermissionGuard>
        </PopupAction>

      ),
    },
  ];


  const fetchReport = async (page = 1, per_page, filter, keyword = "") => {
    setLoading(true)
    const payload = {
      page,
      per_page,
      filter: {
        ...filter,
      },
      keyword,
    }
    try {
      const response = await ReportPoolDataService.getReportPoolWallet(payload)

      const reports = response?.success?.data || []
      const total = response?.success?.total || reports.length
      const totalsData = response?.success?.totals || {};

      const reportList = reports.map((r, i) => ({
        ...r,
        key: r.ID || i,
        unit_price_gb: Number(r.unit_price_gb),
        totalRemainingTraffic: Number(r.totalRemainingTraffic) / 1024,
        purchasedTraffic: Number(r.purchasedTraffic) / 1024,
      }))

      setData(reportList)

      setPagination(prev => ({
        ...prev,
        // current: page,
        total,
      }))
      setSummary({
        totalAccounts: total,
        purchasedTraffic: Number(totalsData.purchasedTraffic || 0) / 1024,
        totalTrafficShared: Number(totalsData.totalTrafficShared || 0) / 1024,
        totalRemainingTraffic: Number(totalsData.totalRemainingTraffic || 0) / 1024,
        import_price: totalsData.import_price || 0,
        price_discount: totalsData.price_discount || 0,
      })
    } catch (error) {
      console.error("Lỗi khi lấy dữ liệu:", error)
      message.error("Không thể lấy dữ liệu")
    } finally {
      setLoading(false)
    }
  }

  useEffect(() => {
    fetchReport(pagination.current, pagination.pageSize, filter, searchValue)
  }, [pagination.current, pagination.pageSize])
  useEffect(() => {
    console.log(pagination)
    if (pagination.current !== 1) {
      setPagination(prev => ({
        ...prev,
        current: 1,
      }))
    } else {
      if (pagination.total !== undefined) {
        fetchReport(
          pagination.current,
          pagination.pageSize,
          filter,
          searchValue,
        )
      }
    }
  }, [filter, searchValue, refresh, monthYear])

  const handleOpenModal = () => {
    setIsModalOpen(true)
  }

  const handleUpdate = (record) => {
    setEditingUser(record)
    setIsEditModalOpen(true)
  }

  const handleViewDetail = async record => {
    // console.log(record);
    setEditingUser(record)
    setModalType("view")
  }

  const handleSearch = value => {
    setSearchValue(value)
  }

  const handleTableChange = newPagination => {
    setPagination({
      ...pagination,
      current: newPagination.current,
      pageSize: newPagination.pageSize,
    })
  }
  const onChange = date => {
    if (date) {
      const month = date.month() + 1 // month() trả về từ 0-11 => cộng 1
      const year = date.year()
      setMonthYear({ month: month, year: year })
      console.log("Tháng:", month)
      console.log("Năm:", year)
    } else {
      console.log("Không có giá trị")
    }
  }

  return (
    <PermissionGuard permission="poolData.walletData.list">
      {/* Header: tiêu đề + nút tạo mới */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginTop: 30,
          marginBottom: 16,
          flexWrap: "wrap",
          gap: 8,
        }}
      >
        <h3
          style={{
            fontSize: "24px",
            fontWeight: "bold",
            color: "#005F90",
            margin: 0,
          }}
        >
          VÍ DATA
        </h3>

      </div>
      {/* <TabsBar /> */}

      {/* Thanh tìm kiếm + nút thao tác nếu có chọn checkbox */}
      <div
        style={{
          display: "flex",
          justifyContent: "space-between",
          alignItems: "center",
          marginBottom: 16,
          flexWrap: "wrap",
          gap: 12,
        }}
      >
        {/* <DatePicker
          onChange={onChange}
          picker="month"
          style={{ width: 150 }}
          format={"MM/YYYY"}
        /> */}
        {/* <FilterAdmin setFilter={setFilter} /> */}
        <div style={{ marginLeft: "auto" }}>
          <Space>
            <InputSearchStyle>
              <Input
                className="custom-input"
                maxLength={50}
                placeholder="Khách hàng"
                // value={searchValue}
                // onChange={e => setSearchValue(e.target.value)}
                onPressEnter={e => setSearchValue(e.target.value)}
              />
              <div className="custom-icon-search">
                <SvgIcon
                  name="searchStatistic"
                  onClick={() => handleSearch(searchValue)}
                />
              </div>
            </InputSearchStyle>
            {/* <ButtonCircle
              style={{ marginLeft: 12 }}
              iconName="import"
              onClick={() => setIsModalImport(true)}
            /> */}
          </Space>
        </div>
      </div>
      {/* Bảng danh sách */}
      <div
        style={{
          display: "flex",
          flexWrap: "wrap",
          flexDirection: "row",
          margin: "10px 0",
          gap: "10px",
        }}
      >
        <div style={{ padding: "0 5px", color: "#007BFF", minWidth: "150px" }}>
          <strong>Tổng dung lượng mua: {Number(summary?.purchasedTraffic || 0)?.toLocaleString()} GB</strong>
        </div>
        <div style={{ padding: "0 5px", color: "#28A745", minWidth: "150px" }}>
          <strong>
            Tổng dung lượng đã dùng: {Number(summary?.totalTrafficShared || 0)?.toLocaleString()} GB
          </strong>
        </div>
        <div style={{ padding: "0 5px", color: "#FF0000", minWidth: "150px" }}>
          <strong>Tổng dung lượng còn lại: {Number(summary?.totalRemainingTraffic || 0)?.toLocaleString()} GB</strong>
        </div>
        <div style={{ color: "#FF0000" }}>
          <strong>Tổng giá nhập: {Number(summary?.import_price || 0)?.toLocaleString()} VND</strong>
        </div>
        <div style={{ color: "#28A745" }}>
          <strong>Tổng giá sau giảm: {Number(summary?.price_discount || 0)?.toLocaleString()} VND</strong>
        </div>
      </div>
      <TableCustom
        rowKey="ID"
        showPagination={true}
        //   rowSelection={{
        //     type: "checkbox",
        //     ...rowSelection,
        //   }}
        isPrimary
        columns={columns}
        loading={loading}
        dataSource={data}
        pagination={{
          current: pagination.current,
          pageSize: pagination.pageSize,
          total: pagination.total,
          showSizeChanger: true,
        }}
        onChange={handleTableChange}
        breported
        scroll={{ x: "max-content" }}
      />

      {/* Modal chỉnh sửa */}
      {(isModalOpen || modalType === "view") && (
        <ReportModal
          open={isModalOpen || modalType === "view"}
          initialValues={
            modalType === "view" ? editingUser : null
          }
          onCancel={() => {
            setIsEditModalOpen(false)
            setIsModalOpen(false)
            setModalType(null)
          }}
          onSubmit={() => {
            fetchReport()
            setIsEditModalOpen(false)
            setIsModalOpen(false)
            setModalType(null)
          }}
          modalType={modalType}
        />
      )}
      <ModalUpdate
        open={isEditModalOpen}
        onClose={() => setIsEditModalOpen(false)}
        initialValues={editingUser}
        reload={() => fetchReport(pagination.current, pagination.pageSize, filter, searchValue)}
      />


      {isModalImport && (
        <CustomModal
          title={"Tải file lên"}
          footer={null}
          size={"small"}
          open={isModalImport}
          onCancel={() => setIsModalImport(false)}
        >
          <ImportModal
            setIsModalImport={setIsModalImport}
            // apiDownloadTemplate={WarehouseService.getWarehouseExcelTemplate}
            apiUploadTemplate={ReportPoolDataService.importVinaSim}
            setRefresh={setRefresh}
            onCancel={() => setIsModalImport(false)}
          />
        </CustomModal>
      )}
    </PermissionGuard>

  )
}

export default ReportPoolWallet
